var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"favorite-grid-skeleton-root"},_vm._l((_vm.count),function(i){return _c('FavoriteCardSkeleton',{key:i})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }